import { Contact } from '../contacts';

export interface EventFilters {
  search: string;
  locationId: string[];
  dateFrom: number;
  page: number;
  limit: number;
}
export interface LocationOption {
  id: string;
  name: string;
}

export interface EventsFilterProps {
  currentDate: Date;
  initialValues: EventFilters;
  locations: LocationOption[];
  onSubmit: (data: Partial<EventFilters>) => void;
}

export interface EventAvailability {
  scheduledAt: number;
}

export interface CalendarCell {
  date: Date;
  eventsAvailable: boolean;
}

export interface EventListItem {
  id: string;
  scheduledAt: number;
  pictureUrl: string;
  url?: string;
  title: string;
  slug: string;
  locationName: string;
  organizerName: string;
  articleUrl?: string;
  recurrenceType?: RecurrenceType;
}

export interface GroupedEvents {
  count: number;
  totalCount: number;
  items: Record<string, EventListItem[]>;
}

export interface EventView {
  id: string;
  title: string;
  slug: string;
  organizerName: string;
  scheduledAt: number;
  url?: string;
  pictureUrl: string;
  locationName: string;
  timeOfDay?: string;
  articleUrl?: string;
  article?: {
    title: string;
    description: string;
  };
  recurrenceType?: RecurrenceType;
  contact?: Contact;
}

export enum RecurrenceType {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3
}
